<template>
    <div>
        <title-component></title-component>
        <div class="row" v-if="pets.length > 0">
            <div class="col">
                <div class="add-pet-link">
                    <a href="javascript:void(0)" v-b-modal.add-pet-modal>
                        {{$t('pets.addPetAction')}}
                    </a>
                </div>
            </div>
        </div>
        <div v-for="(pet) in pets" :key="pet.id">
            <pet-component :petId="pet.id"></pet-component>
        </div>
        <div class="row">
            <div class="col">
                <div>
                    <div class="row">
                        <div class="col">
                            <div class="add-pet-link">
                                <a href="javascript:void(0)" v-b-modal.add-pet-modal>
                                    {{$t('pets.addPetAction')}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <b-modal id="add-pet-modal" ref="add-pet-modal"
                             ok-title="Speichern"
                             cancel-title="Abbrechen"
                             :hide-header=true
                             :hide-footer=true>
                        <add-pet-component></add-pet-component>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {PETS_ACTION_GET_PETS, PETS_GETTER, PETS_NAMESPACE} from '../store/modules/pets-types'
    import TitleComponent from './shared/TitleComponent'
    import PetComponent from './pets/PetComponent'
    import AddPetComponent from './pets/AddPetComponent'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Pets',
        metaInfo () { return { title: i18n.t('pets.meta') } },
        components: {
            'title-component': TitleComponent,
            'pet-component': PetComponent,
            'add-pet-component': AddPetComponent
        },
        computed: {
            ...mapGetters(PETS_NAMESPACE, {
                pets: PETS_GETTER
            }),
            localPets: {
                get () { return this.pets },
                set (value) { this.updatePets({pets: value}) }
            }
        },
        methods: {
            ...mapActions(PETS_NAMESPACE, {
                loadPets: PETS_ACTION_GET_PETS
            })
        },
        created () {
            this.loadPets()
        }
    }
</script>

<style lang="scss" scoped>
    .add-pet-link {
        padding-top: 40px;
        text-align: right;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/PetsComponent.vue